import dayjs from 'dayjs';

import type { CreateJobPostRequest, UpdateJobPostRequest } from '~/api/jobPosts/types';

import type { JobPostForm } from './types';

export const mapJobPostFormDataToPayload = (data: JobPostForm) => {
  return {
    activityIds: data.activityIds,
    closesAt: data.closesAt !== null ? dayjs(data.closesAt).format('YYYY-MM-DD') : null,
    description: JSON.stringify(data.description),
    endsAt: data.endsAt !== null ? dayjs(data.endsAt).format('YYYY-MM-DD') : null,
    experienceLevel: data.experienceLevel,
    locationType: data.locationType,
    price: data.price,
    priceType: data.price === null ? 'Tbd' : data.priceUnit,
    region: data.region,
    startsAt: data.startsAt !== null ? dayjs(data.startsAt).format('YYYY-MM-DD') : null,
    title: data.title,
  } satisfies CreateJobPostRequest | UpdateJobPostRequest;
};
